import React from 'react';
import ReactDOM from 'react-dom/client';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux'
import ReduxThunk from 'redux-thunk'
import * as serviceWorker from './serviceWorker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import App from './components/App';
import reducers from './reducers';
import AppProvider from './hooks';
import { SnackbarProvider } from 'notistack';

const store = createStore(
  reducers,
  applyMiddleware(ReduxThunk)
);
const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <AppProvider>
        <Provider store={store}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }} maxSnack={3}
          >
            <App />
          </SnackbarProvider>
        </Provider>
      </AppProvider>
    </LocalizationProvider>
  </>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
